import { render, staticRenderFns } from "./BlogAnchor.vue?vue&type=template&id=50b40b18&"
import script from "./BlogAnchor.vue?vue&type=script&lang=js&"
export * from "./BlogAnchor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports